<template>
    <div ref="pieChart" style="width: 100%; height: 300px;"></div>
  </template>
  
  <script>
  import * as echarts from "echarts";
  
  export default {
    props: {
      data: {
        type: Array,
        required: true,
      },
    },
    mounted() {
      this.renderChart();
    },
    methods: {
      renderChart() {
        const chart = echarts.init(this.$refs.pieChart);
        chart.setOption({
          tooltip: {
            trigger: "item",
          },
          legend: {
            orient: "vertical",
            left: "left",
          },
          series: [
            {
              type: "pie",
              radius: "50%",
              data: this.data.map((item) => ({
                value: item.value,
                name: item.name,
              })),
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        });
      },
    },
  };
  </script>
  